/**
 * Overlay Loader Component
 * Full-screen overlay loader that appears in the center without causing scroll issues
 */

import { Loader } from '~/components/ui/loader';

interface OverlayLoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function OverlayLoader({ 
  message = "Loading...", 
  size = 'md' 
}: OverlayLoaderProps) {
  return (
    <div className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm">
      <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="flex flex-col items-center space-y-4">
          <Loader size={size} className="mx-auto" />
          <p className="text-muted-foreground text-center">{message}</p>
        </div>
      </div>
    </div>
  );
}
